import React from "react";
import { connect } from "react-redux";
import IngresoActions from "../../../stores/ingreso/Actions";
import CustomInput from "../../../components/CustomForm/CustomInput";
import {
  FormWrapper,
  Form,
  FormGroup,
} from "../../../components/CustomForm/FormStyles";
import useEmpresa from "../../../hooks/useEmpresa";
import { Avatar } from "../../../components/Common/CommonStyles";
import Colors from "../../../themes/Colors";

const AfiliadoIngresoDetalle = (props) => {
  const { formCierreCuentasData } = props;

  const empresa = useEmpresa();

  return (
    <FormWrapper
      flexDirection={"row"}
      flex={"1"}
      borderColor={empresa?.COLOR_PRINCIPAL}
    >
      <FormWrapper borderColor={Colors.transparent} maxWidth={"100px"}>
        <Avatar src={formCierreCuentasData?.foto} />
      </FormWrapper>

      <FormWrapper borderColor={Colors.transparent}>
        <Form>
          <FormGroup>
            <CustomInput
              type={"text"}
              width={"470px"}
              placeholder={"Nombre"}
              label={"Nombre"}
              value={formCierreCuentasData?.nombreAfiliado}
              disabled={true}
            />
          </FormGroup>
          <FormGroup />
          <FormGroup>
            <CustomInput
              type={"text"}
              placeholder={"Edad"}
              label={"Edad"}
              value={formCierreCuentasData?.edad}
              disabled={true}
            />
          </FormGroup>
          <FormGroup>
            <CustomInput
              type={"text"}
              placeholder={"Número de " + empresa?.TIPO_CLIENTE}
              label={empresa?.TIPO_CLIENTE}
              value={formCierreCuentasData?.numeroAfiliado}
              disabled={true}
            />
          </FormGroup>
          <FormGroup>
            <CustomInput
              type={"text"}
              placeholder={"Cédula"}
              label={"Cédula"}
              value={formCierreCuentasData?.cedula}
              disabled={true}
            />
          </FormGroup>
          <FormGroup>
            <CustomInput
              type={"text"}
              placeholder={"NSS"}
              label={"NSS"}
              value={formCierreCuentasData?.nss}
              disabled={true}
            />
          </FormGroup>
          <FormGroup>
            <CustomInput
              type={"text"}
              placeholder={"Plan"}
              label={"Plan"}
              value={formCierreCuentasData?.plan}
              disabled={true}
            />
          </FormGroup>
          <FormGroup />
          <FormGroup />
        </Form>
      </FormWrapper>
    </FormWrapper>
  );
};

const mapStateToProps = (state) => ({
  authUserData: state.auth.authUserData,
  authUserLoading: state.auth.authUserLoading,
  authUserError: state.auth.authUserError,

  formCierreCuentasData: state.ingreso.formCierreCuentasData,
  formCierreCuentasLoading: state.ingreso.formCierreCuentasLoading,
});

const mapDispatchToProps = {
  formCierreCuentas: IngresoActions.formCierreCuentas,
};

const connector = connect(mapStateToProps, mapDispatchToProps);

export default connector(AfiliadoIngresoDetalle);
